import axios from 'axios'

const baseURL = process.env.VUE_APP_SERVICIOS_URL

const api_token = process.env.VUE_APP_SERVICIOS_TOKEN

const http = axios.create({ baseURL })

// Add api_token to url for each request
http.interceptors.request.use(config => Object.assign(config, { url: `${config.url}/${api_token}`}))

http.interceptors.response.use(({data}) => data)

export default http